import { DocumentFileIcon } from '@room-match/shared-ui-components';
import { DocumentContainer, DocumentName, DocumentIconContainer } from './Document.styles';
import { ProgressOverlay } from 'components/Progressoverlay/ProgressOverlay';
type DocumentUploadingItemProps = {
  name: string;
  uploadingProgress?: number | null;
};

const DocumentUploadingItem = ({ name, uploadingProgress }: DocumentUploadingItemProps) => {
  return (
    <DocumentContainer>
      <DocumentIconContainer>
        <DocumentFileIcon />
      </DocumentIconContainer>
      <DocumentName>{name}</DocumentName>
      {uploadingProgress ? <ProgressOverlay progress={uploadingProgress || 0} /> : null}
    </DocumentContainer>
  );
};

export default DocumentUploadingItem;
